import { render, staticRenderFns } from "./SupportLandingPage.vue?vue&type=template&id=4648f752&scoped=true"
import script from "./SupportLandingPage.vue?vue&type=script&lang=js"
export * from "./SupportLandingPage.vue?vue&type=script&lang=js"
import style0 from "./SupportLandingPage.vue?vue&type=style&index=0&id=4648f752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648f752",
  null
  
)

export default component.exports